const linkStyle = {
    display: "inline-block",
    padding: "0.85rem 0",
    fontSize: "1rem",
};

const OpenPageLink = ({ to, children }) => (
    <a
        className="clickable-link"
        href={to}
        target="_blank"
        rel="noreferrer"
        style={linkStyle}
    >
        {children}
    </a>
);

const networkQuery = (data, extra = {}) => {
    const id = data?.networkId || data?.networkKey;
    const params = new URLSearchParams();
    if (data?.networkType === "benefit") {
        if (id) params.set("benefitNetworkId", id);
    } else if (id) {
        params.set("supplierNetworkHccId", id);
    }
    if (data?.networkName) params.set("networkName", data.networkName);
    Object.entries(extra).forEach(([k, v]) => {
        if (v != null && v !== "") params.set(k, v);
    });
    return params.toString();
};

const ProviderNetwork = ({ data }) => {
    const isBenefit = data?.networkType === "benefit";
    const typeLabel = isBenefit ? "Benefit network" : "Supplier network";
    const id = data?.networkId || data?.networkKey;
    const qs = networkQuery(data);
    const relatedQs = networkQuery(data, {
        type: isBenefit ? "supplier" : "benefit",
    });

    return (
        <>
            <p style={{ fontSize: "1.2rem", fontWeight: 600, padding: "1rem 0rem .25rem 0rem" }}>
                {data?.networkName || data?.networkId}
            </p>
            <p className="sub-title">
                {typeLabel}
                {id ? ` · ${id}` : ""}
                {data?.status ? ` · ${data.status}` : ""}
            </p>
            {data?.networkDesc && data.networkDesc !== data.networkName && (
                <p className="sub-title" style={{ paddingTop: ".35rem" }}>{data.networkDesc}</p>
            )}
            <p className="sub-title" style={{ paddingTop: ".65rem", maxWidth: "42rem" }}>
                {isBenefit
                    ? "Benefit networks set in-network tiers on a plan. Open a roster below in a new tab."
                    : "Supplier networks are operational/contracting groups. Open a roster below in a new tab."}
            </p>

            {id ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", paddingTop: ".4rem" }}>
                    <OpenPageLink to={`/providers/suppliers?${qs}`}>
                        Suppliers in this network →
                    </OpenPageLink>
                    <OpenPageLink to={`/providers/roles?${qs}`}>
                        Roles in this network →
                    </OpenPageLink>
                    {!isBenefit && (
                        <OpenPageLink to={`/providers/contracts?${qs}`}>
                            Contracts for this supplier network →
                        </OpenPageLink>
                    )}
                    <OpenPageLink to={`/providers/networks?${relatedQs}`}>
                        {isBenefit ? "Supplier networks in this benefit network →" : "Benefit networks for this supplier network →"}
                    </OpenPageLink>
                </div>
            ) : (
                <p className="sub-title" style={{ paddingTop: "1rem" }}>This row has no network id, so rosters cannot be opened.</p>
            )}
        </>
    );
};

export default ProviderNetwork;
